import React, { FC } from "react"

import useCommonUrlsAndNumbers from "@hooks/useCommonUrlsAndNumbers"

import Prefooter from "@components/Prefooter/Prefooter"

type GetStartedPrefooterProps = {
  ctaLabel?: string,
  ctaText?: string,
  link?: string,
  title?: string,
}

/*
  WARNING: this is a legacy component that provides some useful (legacy copy) defaults and wraps Prefooter.
  this component will be deprecated in the near future, do not use!
*/
const GetStartedPrefooter: FC<GetStartedPrefooterProps> = ({
  ctaLabel,
  ctaText,
  link,
  title,
}) => {
  const {
    trialDaysLength,
    signupPlusUrl,
  } = useCommonUrlsAndNumbers()

  const DEFAULTS = {
    ctaLabel: `Free ${trialDaysLength}-day Trial`,
    ctaText: `Want to learn what Help Scout can do for you? See for yourself with a free trial — we'll happily extend you if you need more time.`,
    link: signupPlusUrl,
    title: `Get started with Help Scout`,
  }

  return (
    <Prefooter
      title={title || DEFAULTS.title}
      bodyText={{ bodyText: ctaText || DEFAULTS.ctaText }}
      button1Label={ctaLabel || DEFAULTS.ctaLabel}
      button1Url={link || DEFAULTS.link}
    />
  )
}

export default GetStartedPrefooter